module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/缺省插图-无内容.68c04.png";